// Discrete floating hint (bottom-left, desktop only) advertising the two
// keyboard shortcuts. Chips are clickable — they open the same modals, so the
// hint doubles as a mouse affordance. Sits low-opacity until hovered.
import { useState } from 'react'
import Icon from './Icons'
import ShortcutsHelp from './ShortcutsHelp'
import '../styles/ShortcutHints.css'

const isMac = typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent || '')
const MOD = isMac ? '⌘' : 'Ctrl'

const ShortcutHints = ({ onOpenSearch, onOpenPalette }) => {
  const [helpOpen, setHelpOpen] = useState(false)
  return (
    <>
      <div className="shortcut-hints" aria-hidden="false">
        <button className="shortcut-hint" onClick={onOpenSearch} title="Rechercher une région, un pays…">
          <Icon name="search" size={12} />
          <span className="shortcut-hint-label">Rechercher</span>
          <kbd className="shortcut-keys"><span>{MOD}</span><span>F</span></kbd>
        </button>
        <button className="shortcut-hint" onClick={onOpenPalette} title="Palette de commandes">
          <Icon name="menu" size={12} />
          <span className="shortcut-hint-label">Commandes</span>
          <kbd className="shortcut-keys"><span>{MOD}</span><span>K</span></kbd>
        </button>
        <button className="shortcut-hint" onClick={() => setHelpOpen(true)} title="Tous les raccourcis clavier / souris">
          <Icon name="info" size={12} />
          <span className="shortcut-hint-label">Raccourcis</span>
          <kbd className="shortcut-keys"><span>?</span></kbd>
        </button>
      </div>
      <ShortcutsHelp open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  )
}

export default ShortcutHints
